var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 76,
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.125 58.25C110.125 59.4805 109.578 60.5742 108.758 61.3945L73.7578 96.3945C72.9375 97.2148 71.8438 97.625 70.75 97.625C69.5195 97.625 68.4258 97.2148 67.6055 96.3945L50.1055 78.8945C49.2852 78.0742 48.875 76.9805 48.875 75.75C48.875 73.2891 50.7891 71.375 53.25 71.375C54.3438 71.375 55.4375 71.9219 56.2578 72.7422L70.75 87.0977L102.605 55.2422C103.426 54.4219 104.52 53.875 105.75 53.875C108.074 53.875 110.125 55.7891 110.125 58.25Z",
    fill: "#38A169"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTick);
export default ForwardRef;